import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerGroupsInlineStyles = /*#__PURE__*/function () {
  function BlockerGroupsInlineStyles() {
    _classCallCheck(this, BlockerGroupsInlineStyles);
  }

  _createClass(BlockerGroupsInlineStyles, null, [{
    key: "cookieScroll",
    value: function cookieScroll(_ref) {
      var fontSize = _ref.design.fontSize,
          _ref$bodyDesign = _ref.bodyDesign,
          descriptionInheritFontSize = _ref$bodyDesign.descriptionInheritFontSize,
          descriptionFontSize = _ref$bodyDesign.descriptionFontSize,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-cookie-scroll",
        style: {
          fontSize: descriptionInheritFontSize ? +fontSize : +descriptionFontSize,
          textAlign: "left",
          marginBottom: 10,
          maxHeight: 400,
          overflowY: "scroll",
          paddingRight: 10
        }
      };
    }
    /**
     * Use `visible` together with `useLayoutEffect` to avoid flickering.
     * This is needed because the SVG icons of ant are a bit flickering.
     */

  }, {
    key: "checkbox",
    value: function checkbox(_ref2, visible, checked, isDisabled, fontSize) {
      var borderRadius = _ref2.layout.borderRadius,
          _ref2$group = _ref2.group,
          headlineFontSize = _ref2$group.headlineFontSize,
          checkboxBg = _ref2$group.checkboxBg,
          checkboxBorderWidth = _ref2$group.checkboxBorderWidth,
          checkboxBorderColor = _ref2$group.checkboxBorderColor,
          checkboxActiveBg = _ref2$group.checkboxActiveBg,
          checkboxActiveBorderColor = _ref2$group.checkboxActiveBorderColor,
          checkboxActiveColor = _ref2$group.checkboxActiveColor,
          antiAdBlocker = _ref2.customCss.antiAdBlocker;
      var useFontSize = fontSize || headlineFontSize;
      var height = +useFontSize + +checkboxBorderWidth * 2 + 6;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-checkbox",
        style: {
          cursor: isDisabled ? "not-allowed" : "pointer",
          opacity: isDisabled ? 0.5 : undefined,
          color: checked ? checkboxActiveColor : checkboxBg,
          display: visible ? "inline-block" : "none",
          background: checked ? checkboxActiveBg : checkboxBg,
          border: "".concat(checkboxBorderWidth, "px solid ").concat(checked ? checkboxActiveBorderColor : checkboxBorderColor),
          padding: 3,
          height: height,
          width: height,
          marginRight: 10,
          borderRadius: +borderRadius,
          verticalAlign: "middle",
          lineHeight: 0
        }
      };
    }
  }, {
    key: "linkMore",
    value: function linkMore(_ref3, isHover) {
      var linkTextDecoration = _ref3.design.linkTextDecoration,
          _ref3$group = _ref3.group,
          linkColor = _ref3$group.linkColor,
          linkHoverColor = _ref3$group.linkHoverColor,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-group-more",
        style: {
          color: isHover ? linkHoverColor : linkColor,
          textDecoration: linkTextDecoration
        }
      };
    }
  }, {
    key: "cookie",
    value: function cookie(_ref4) {
      var antiAdBlocker = _ref4.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-cookie",
        style: {
          marginTop: 10
        }
      };
    }
  }, {
    key: "cookieProperty",
    value: function cookieProperty(_ref5) {
      var _ref5$group = _ref5.group,
          groupBorderWidth = _ref5$group.groupBorderWidth,
          groupBorderColor = _ref5$group.groupBorderColor,
          antiAdBlocker = _ref5.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-cookie-prop",
        style: {
          borderLeft: groupBorderWidth > 0 ? "1px solid ".concat(groupBorderColor) : undefined,
          paddingLeft: 15
        }
      };
    }
  }]);

  return BlockerGroupsInlineStyles;
}();

export { BlockerGroupsInlineStyles };